<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>快捷支付</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.cash.route.hangmuxitong.com/quickpay/cash</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://cash.yunfastpay.com/quickpay/cash</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS1119</td></tr>
          <tr><td>组织机构代码</td><td>orgCd</td><td>String（15）</td><td>是</td><td>测试：201807123027134</td></tr>
          <tr><td>商户号</td><td>mchtCd</td><td>String (15)</td><td>是</td><td>测试：MCHT100005803</td></tr>
          <tr><td>商户的流水号</td><td>outOrderId</td><td>String（32）</td><td>是</td><td>与商城订单关联的支付订单号</td></tr>
          <tr><td>用户标示</td><td>buyerCd</td><td>String（48）</td><td>是</td><td>用户表主键，标示一个用户</td></tr>
          <tr><td>交易金额</td><td>transAmt</td><td>String（16）</td><td>是</td><td>单位：元（最多两位小数）</td></tr>
          <tr><td>订单标题</td><td>outOrderTitle</td><td>String（256）</td><td>是</td><td></td></tr>
          <tr><td>订单描述</td><td>outOrderDesc</td><td>String（512）</td><td>否</td><td></td></tr>
          <tr><td>异步通知地址</td><td>notifyUrl</td><td>String(255)</td><td>是</td><td></td></tr>
          <tr><td>是否分账</td><td>isSplitBill</td><td>String(1)</td><td>是</td><td>不传，传0代表不分账。传1代表分帐</td></tr>
          <tr><td>分账列表</td><td>itemsList</td><td>JSON</td><td>否</td><td>isSplitBill为分账，必填</td></tr>
          <tr><td>是否子商户</td><td>item1</td><td>String(16)</td><td>否</td><td>默认：1</td></tr>
          <tr><td>分账角色</td><td>item2</td><td>String(16)</td><td>否</td><td></td></tr>
          <tr><td>分账接收方</td><td>item3</td><td>String(32)</td><td>否</td><td></td></tr>
          <tr><td>分账ID类型</td><td>item5</td><td>String(16)</td><td>否</td><td>00</td></tr>
          <tr><td>分账描述</td><td>item9</td><td>String(32)</td><td>否</td><td></td></tr>
          <tr><td>分账金额</td><td>item10</td><td>String(16)</td><td>否</td><td>金额（元）</td></tr>
          <tr><td>分账者省代码</td><td>item11</td><td>String(10)</td><td>否</td><td></td></tr>
          <tr><td>分账者市代码</td><td>item12</td><td>String(10)</td><td>否</td><td></td></tr>
          <tr><td>分账者区代码</td><td>item13</td><td>String(10)</td><td>否</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>测试秘钥：S5DH89W2W37E4CF6KJSH23SK</p>
        <p>订单支付(100.30元)，请求报文：</p>
        <code>{
          "keyField":"MCHT100005803",
          "typeField":"MCHT",
          "dataField": "suDHzFRX+KNmiVObMqilUIjM5pY+a3O2zPER+oyCiprswlPNtEFAG815vy6MLwZbd+vFvYhT63RovJtOA0WIyQNDLRLPfBk4YOp04CyaQzCgD2v3cZdxxTKzMxnZsWOxg5KIA/gz3aFDUa509ELM1mKEJ8ANpilmRk0qQeSg5zFvcklg1TnTgeJhR3HA6RkGDGGPfvMQyxeszeBrYnR/x1hvbeu2IKbwtf6F32HOADfeomhOJhjINyvsus4ukE4b0G3tZUiJjLnl12WBVkitt9X8ksohAMY/QgZf/4KB8PoHcsL8migJNAkvB8DskFMmXXrEIQuiMJCcoel8Zw2paR1cHb53w7UApl06oOkTv0/VMq1l9jDszxIWU9QVsUfpEQlbu7iETmYraOHqZ//8QA=="
          }</code>
        <p>解密后：</p>
        <code>{
          "orgCd":"201807123027134",
          "mchtCd":"MCHT100005803",
          "outOrderId":"2018071254515454545",
          "buyerCd":"sdh45fds5gsd",
          "transAmt":"100.30",
          "outOrderTitle":"会议室投影仪",
          "outOrderDesc":"100寸,高还原，白色投影仪1台",
          "notifyUrl":"http://test.cash.route.hangmuxitong.com/paynotice"
          }
        </code>
        <h4 class="common-margin-top">应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（10）</td><td>是</td><td>成功：0000 失败：其它</td></tr>
          <tr><td>平台流水号</td><td>orderCd</td><td>String(20)</td><td>否</td><td>平台返回的交易流水号</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（100）</td><td>是</td><td></td></tr>
          <tr><td>回调链接</td><td>reqUrl</td><td>String（512）</td><td>是</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Kj',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/base/kbin', 'name': '卡bin查询'},
        {'url': '/interface/kj/kjbk', 'name': '快捷支付接口'},
        {'url': '/interface/kj', 'name': '快捷支付收银'},
        {'url': '/interface/tk', 'name': '退款'},
        {'url': '/interface/cx', 'name': '交易查询'},
        {'url': '/interface/pldf', 'name': '批量代付'},
        {'url': '/interface/ybtz', 'name': '异步通知'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Kj.vue